var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobileGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 20,
    viewBox: "0 0 63 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8538 19.1021L30.9497 0.883637H34.5249L26.4289 19.1021H22.8538Z",
    fill: "#4BFFB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3171 19.1021L39.4131 0.883637H42.9883L34.8923 19.1021H31.3171Z",
    fill: "#4BFFB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2279 0.88359L24.7517 4.04685L2.60884 8.26459L19.1638 16.0673L17.7925 19.1164L0.5 10.3727L0.499999 5.73393L26.2279 0.88359Z",
    fill: "#4BFFB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1122 13.9585L17.7925 19.1164L15.051 17.5169L18.8469 9.52985L22.432 8.89719L20.1122 13.9585Z",
    fill: "#4BFFB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3027 19.0196L48.2228 0.883588L53.58 0.883588L62.5 19.0196L58.915 19.0196L50.9014 2.57066L42.8878 19.0196L39.3027 19.0196Z",
    fill: "#4BFFB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobileGreen);
export default __webpack_public_path__ + "static/media/logo-mobile-green.c9ccef1d5a35ab3820f7da4282938ded.svg";
export { ForwardRef as ReactComponent };